<ng-container *ngIf="selectedNews">
    <app-back-navigation [backTitle]="'buttons.back'" (onClickBack)="onGoBack()"></app-back-navigation>

  <div class="col-12 mb-3">
    <app-news-view-header 
      [title]="selectedNews.title" 
      [author]="selectedNews.autorName" 
      [date]="selectedNews.publishDate"
      [authorIconClass]="'bi bi-person-circle'"
    ></app-news-view-header>
  </div>

  <div class="row view-article-related">
    <div class="col-12" [ngClass]="{'col-md-8': relatedNews && relatedNews.length}">
      <app-write-article-form [form]="form" [isViewMode]="true"></app-write-article-form>
    </div>
    @if(relatedNews && relatedNews.length) {
      <div class="col-12 col-md-4">
        <app-related-news [relatedNews]="relatedNews" [form]="form" [isViewMode]="true"></app-related-news>
      </div>
    }

  </div>
</ng-container>